// extracted by mini-css-extract-plugin
export default {"headline":"t43shnESAPFbH6TOtjDC","points":"G0Ke6dENERkQJA9K64zn","noData":"VsNBV4oR0IFHrpuCD42w"};